import { myHistory } from "utils";

export default function forwardTo(location: string) {
    myHistory.history.push(location);
}